import coverImage1 from 'assets/images/portrait-colors.jpg';
import coverImage2 from 'assets/images/landscape-tiles.jpg';
import coverImage3 from 'assets/images/portrait-wall.jpg';
import coverImage4 from 'assets/images/portrait-papers.jpg';

const DefaultCoverImages = [coverImage1, coverImage2, coverImage3, coverImage4];

export function generateFallbackImage(nodeId: string): string {
  const fallbackIndex = nodeId
    .trim()
    .split('')
    .reduce((i, s) => i + s.charCodeAt(0), 0);
  return DefaultCoverImages[fallbackIndex % DefaultCoverImages.length];
}
